import React, { useState, useRef } from 'react'

import { Mobile, NotMobile } from '~/components/responsive'
import { useOutsideClick } from '~/hooks/outside-click'
import { isDesktop } from '~/utils/device'

import {
  MessageContentBlock,
  Wrapper,
  TooltipLink,
  Icon,
} from './tooltip.styles'

import type { ReactNode } from 'react'

export type Props = {
  message: string
  className?: string
}

export default function Tooltip({ message, className }: Props) {
  const [showTooltip, setShowTooltip] = useState(false)
  const infoIconRef = useRef(null)

  useOutsideClick(infoIconRef, () => setShowTooltip(false))

  return (
    <Wrapper
      ref={infoIconRef}
      onMouseEnter={() => {
        if (isDesktop()) setShowTooltip(true)
      }}
      onMouseLeave={() => {
        if (isDesktop()) setShowTooltip(false)
      }}
      className={className}
    >
      <Mobile>
        <Icon
          glyph="circle-info"
          onClick={(e) => {
            e.preventDefault()
            setShowTooltip((showTooltip) => !showTooltip)
          }}
        />
      </Mobile>
      <NotMobile>
        <Icon glyph="circle-info" />
      </NotMobile>
      {showTooltip && (
        <MessageContentBlock
          key={`${infoIconRef?.current?.offsetLeft}`}
          $offsetLeft={infoIconRef?.current?.getBoundingClientRect().left || 0}
          componentOverrides={{
            a: ({ href, children }: { href?: string; children: ReactNode }) => (
              <TooltipLink
                to={href}
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {children}
              </TooltipLink>
            ),
          }}
        >
          {message}
        </MessageContentBlock>
      )}
    </Wrapper>
  )
}
